// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"TemplatesTableBody_nameCell__hJYgj","updatedCell":"TemplatesTableBody_updatedCell__3j7WY"};